module.exports = __webpack_public_path__ + "static/media/mouse.d04c9976.svg";